<template>
  <div class="comp-fh-main-table">
    <fh-table
      v-if="data.columns?.length"
      :columns="data.columns"
      ref="fhTableRef"
      :data="tableData"
      :viewId="data.viewId"
      :pagination="paginationObj"
      :bordered="false"
      :loading="data.loading"
      :showColOverlay="data.showColOverlay"
      :filterFieldArray="filterFieldArray"
      :maxHeight="maxHeight"
      @paginationEvent="paginationEvent"
      @headerIconMore="headerIconMore"
      v-model:activeRowKeys="activeRowKeys"
      :isChecked="true"
      :expandIcon="data.multiTable"
      checkBoxClassName="checkbox-custom-class"
      :errorRowList="errorRowList"
      :summaryOptions="summaryOptions"
      v-model:expandedRowKeys="expandedRowKeys"
      activeRowType="single"
      :virtual="{ enabled: grayVirtualEnabled, dynamicHeight: true }"
      @expandChange="rehandleExpandChange"
      @columnResize="columnResize"
      :checkedParams="{ width: aiSummaryOptions.enabled ? 92 : 60, checked: selectTableIds }"
      :rowDragParams="rowDragParams"
      @rowDragend="onRowDragEnd"
      :cornerMark="true"
      @summaryChange="summaryChange"
      @columnsChange="getSummaryData"
    >
      <template #empty>
        <jw-empty :img-src="noDataSvg" :description="props.buttonUniversalAdd ? '暂无数据，你可以点击下方按钮新建数据' : $t('暂无数据')"></jw-empty>
        <jw-button v-if="props.buttonUniversalAdd" @click="addRow" type="outline" :style="{ minWidth: '100px', cursor: 'pointer' }" size="medium">{{ props.buttonUniversalAdd.label }}</jw-button>
      </template>
      <!-- 错误角标 -->
      <template #cornerMark="{ row }">
        <template v-if="row?.computedInfo?.status == 2">
          <ly-computed-icon-tips :computedInfo="row?.computedInfo" />
        </template>
      </template>
      <!-- 自定义复选框 -->
      <template #customCheckbox="{ row, index }">
        <!-- 数据下标 -->
        <div v-if="!computingStatus.includes(row?.computedInfo?.status)" :class="['index-num', selectTableIds.includes(row.id) ? 'index-num-hide' : 'index-num-show']">{{ index + 1 }}</div>

        <div class="checkbox-container">
          <!-- 增加处理中状态 3 -->
          <div class="computed-status-container" v-if="computingStatus.includes(row?.computedInfo?.status)">
            <jw-tooltip :content="row?.computedInfo?.status === 1 ? '计算处理中' : '审批处理中'">
              <icon-refresh :size="16" style="color: rgb(var(--primary-6))" spin @click="refreshComputedStatus([row.id])" class="computed-status-icon" />
            </jw-tooltip>
          </div>

          <!-- 操作 & 查看详情 -->
          <div v-if="!computingStatus.includes(row?.computedInfo?.status)" :class="['index-handle-box', selectTableIds.includes(row.id) ? 'index-handle-box-show' : 'index-handle-box-hide']">
            <jw-checkbox class="show-index-checkbox" :model-value="selectTableIds.includes(row.id)" @change="selectSingle($event, row.id)"></jw-checkbox>
          </div>
          <jw-tooltip content="查看详情">
            <div class="index-detail-icon" @click.stop="toDetails(row)">
              <qfei-icon-full-screen-outlined />
            </div>
          </jw-tooltip>

          <jw-tooltip v-if="aiSummaryOptions.enabled" :content="$t('AI总结汇总')">
            <div class="index-ai-icon" :data-id="row.id" @click="aiSummaryOptions.setActiveData(row)">
              <img :src="aiIcon" :alt="$t('AI总结汇总')" />
            </div>
          </jw-tooltip>
        </div>
      </template>
      <!-- 展开行图标 -->
      <template #expandIcon="{ rowKey }">
        <div class="fh-table-expand-icon">
          <qfei-icon-caret-right-outlined v-if="!expandedRowKeys.includes(rowKey)" style="font-size: 10px" />
          <qfei-icon-caret-down-outlined v-else style="font-size: 10px" />
        </div>
      </template>
      <!-- 自定义标题复选框 -->
      <template #customTitleCheckbox>
        <jw-checkbox :disabled="allIds.length == 0" :model-value="(selectTableIds?.length === allIds?.length && allIds.length) || false" :indeterminate="indeterminate" @change="selectAll" style="padding-left: 0" />
      </template>
      <!-- 字段图标 -->
      <template #prefix="{ col }">
        <component :is="getFieldIcn(col)" />
      </template>
      <!-- 筛选Icon -->
      <template #extraHeader="{ colKey, sort }">
        <template v-if="filterFieldArray.includes(colKey) || typeof sort === 'boolean'">
          <qfei-icon-filter-outlined v-if="typeof sort !== 'boolean'" />
          <qfei-icon-filter-asc-outlined v-else-if="sort === true" />
          <qfei-icon-filter-desc-outlined v-else />
        </template>
        <template v-else>
          <qfei-icon-ascending-order-outlined v-if="sort === true" />
          <qfei-icon-descending-order-outlined v-else />
        </template>
      </template>
      <!-- 嵌套表格【二级】 -->
      <template #expandRow="{ row }">
        <fh-nest-table v-if="isShowNestTable" :parentEntity="entity" :multiTable="nestColumnsFields" :parentId="row?.id" />
      </template>
    </fh-table>
    <template v-else>
      <fh-list-skeleton></fh-list-skeleton>
    </template>
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef" @cb="refreshList('detail')" :mask="mask"></ly-detail>
    <div v-if="data.showColOverlay" class="overlay" @mousedown.stop="handleMouseDown" @mouseup.stop="handleMouseUp">
      <fh-table-header-more ref="qfTableHeaderMoreRef" @mousedown.stop @mouseup.stop :headerColInfo="headerColInfo" :isSubForm="isIconSubForm" :column="headerColumn" :viewId="data.viewId" :ruleForm="data.ruleForm" @colTitleFrozen="colTitleFrozen" @sortChange="sortChange" @getConditionParams="getConditionParams"> </fh-table-header-more>
    </div>
    <div class="batch-shortcut-btn" v-if="shouldShowButtonGroup" :style="{ bottom: hasSummary ? '90px' : '55px' }">
      <fh-shortcut-batch :entity="entity" :viewId="data.viewId" :tableSelectIds="selectTableIds" :tableDataLength="tableData?.length" :showShortcutBtn="shouldShowShortcutBtn" :showBatchBtn="shouldShowBatchBtn" :tableRow="tableRow" :columnFieldList="data.fieldList" :shortcutBtnPermission="shortcutBtnPermission" :batchBtnPermission="batchBtnPermission" :bingDataList="bingDataList" :checkLifeStatus="checkLifeStatusWrapper" @clearSelected="clearSelected" @shortcutBtnCb="shortcutBtnCb" @batchBtnCb="batchBtnCb"></fh-shortcut-batch>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, provide, computed, watch, nextTick, onUnmounted, onBeforeUnmount, inject } from 'vue';
import { fieldAggregationService, tableService } from '@/api/';
import { tools } from '@/utils/tools';
import CONFIG from '@/config/config';
import { useUserStore, useLayoutStore, useFilterListStore, useMainTableStore } from '@/store';
import { bingOrgId, permissionsObjList, computingStatus } from '@/utils/const';
import { useI18n } from 'vue-i18n';
import noDataSvg from '@/assets/images/no-data-150.svg';
// 组件引入
import FhTable from '../fh-table/fh-table.vue';
import FhTableHeaderMore from '../fh-table-header-more/fh-table-header-more.vue';
import FhNestTable from '../fh-nest-table/fh-nest-table.vue';
import fhShortcutBatch from '../fh-shortcut-batch/fh-shortcut-batch.vue';
import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';
import { QfeiIconFilterAscOutlined, QfeiIconFilterDescOutlined, QfeiIconFilterOutlined, QfeiIconDescendingOrderOutlined, QfeiIconAscendingOrderOutlined, QfeiIconCaretRightOutlined, QfeiIconCaretDownOutlined, QfeiIconFullScreenOutlined } from '@qfei-design/icons-vue';
// hooks引入
import useMainTable from '@/hooks/main-table';
import { useComputedStatusPolling } from '@/hooks/ly-table-config';
import { useLifeStatus } from '@/hooks/life-status';
import useFields from '@/hooks/fields';
import { summaryStatus } from '@/components/table/contants';
import aiIcon from '@/assets/images/ai/ai-icon.svg';

const keywords = ref(''); // 搜索关键字
const searchFieldsList = ref([]); // 搜索字段

// 使用防抖处理搜索
// const handleSearch = _.debounce(async (value) => {
//   console.log('handleSearch', value);
//   await nextTick();
//   highlightText(value);
// }, 300);

import useTableColumns from '@/hooks/table-columns'; // 新增：引入自定义 hooks
import { Message } from '@arco-design/web-vue';
import { isAggregationField } from '@/components/table/utils';

const { createChildColumns, createColumnConfig, extractFields } = useTableColumns(() => {
  delayGetSummary();
});
const { getNestField, nestColumnField } = useMainTable();
// 使用store
const useTableInfo = useMainTableStore();
// 使用生命状态hook，获取checkLifeStatus方法
const { checkLifeStatus } = useLifeStatus();

// 创建包装函数，在父组件中传递参数
const checkLifeStatusWrapper = (promptTitle) => {
  return checkLifeStatus(selectTableIds.value, tableData.value, promptTitle);
};
const useLayout = useLayoutStore(); //视图及布局store
const useFilterList = useFilterListStore(); // 筛选条件store
const props = defineProps({
  entityId: {
    //对象的entity【必传】
    type: Number || String,
    default: undefined
  },
  viewId: {
    type: Number || String,
    default: undefined
  },
  record: {
    type: Object,
    default: () => ({})
  },
  customerId: {
    type: Number || String
  },
  maxHeight: {
    type: Number,
    default: 0
  },
  conditionsType: {
    type: Object,
    default: () => {}
  },
  allFieldsList: {
    type: Array,
    default: () => []
  },
  allFieldsListObj: {
    type: Object,
    default: () => {}
  },
  viewsObj: {
    type: Object,
    default: () => {}
  },
  shortcutBtnPermission: {
    type: Array,
    default: () => []
  },
  batchBtnPermission: {
    type: Array,
    default: () => []
  },
  // 新增按钮权限
  buttonUniversalAdd: {
    type: Object,
    default: () => {}
  }
});
//是否显示汇总行
const summaryOptions = reactive({
  enabled: true,
  data: {},
  formatter: (...args) => tools.formatSummary(...args)
});
const { userInfo } = useUserStore();
const emits = defineEmits(['cb', 'update:loading', 'loadAdvancedComp', 'cbAdd', 'cbTotalCount']);
// 虚拟列表灰度租户
const grayVirtualEnabled = [60, 31379, 31720, 31843].includes(userInfo?.orgId);
const { t } = useI18n();
//类型1-线索 2-客户 3-商机 4-产品 6--报价单详情 7--报价单明细 8 销售合同 9 销售合同明细10销售订单13退货单14退货单产品
const entity = ref(props.entityId);
const fieldsSort = ref([]);
const data = reactive({
  fieldList: [], //获取字段列表所有数据
  loading: true,
  columns: [],
  id: '', //ID、
  record: [],
  leadsID: [],
  viewId: null,
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    objList: {}, //fieldKey：obj 类型
    filterType: {}, //中间
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    conditions: []
  },
  showColOverlay: false, // 父组件弹窗状态
  specialProduct: [7, 9, 11, 14, 32], //特殊产品对象
  multiTable: null //多层级表格信息
});
// 先渲染列表，再调用的字段条件类型接口，所以需要用watch监听
watch(
  () => props.conditionsType,
  (val) => {
    const dr = data.ruleForm;
    dr.filterType = val;
    dr.leadsFieldList = props.allFieldsList;
    dr.objList = props.allFieldsListObj;
  },
  {
    deep: true,
    immediate: true
  }
);

// 汇总
const getSummaryData = async () => {
  if (!summaryOptions.enabled) return;
  resetSummaryData();
  const res = await fieldAggregationService.getListPageAggregation({
    entity: entity.value,
    id: data.viewId || props.viewId,
    ...highFilterParams.value,
    ...filterParams.value
  });
  if (!res.error) {
    const result = res.result || {};
    Object.keys(summaryOptions.data).forEach((key) => {
      summaryOptions.data[key] = result[key] ?? summaryStatus.error;
    });
  } else {
    console.error(res.error?.msg);
  }
};

// AI汇总
const aiSummaryOptions = inject('aiSummaryOptions', {});

// 后端es写入延迟 快捷编辑延迟5秒获取汇总结果
let getSummaryTimer = null;
const delayGetSummary = () => {
  clearTimeout(getSummaryTimer);
  if (!summaryOptions.enabled) return;
  resetSummaryData();
  getSummaryTimer = setTimeout(() => {
    getSummaryData();
  }, 5000);
};

const summaryChange = async (val) => {
  const { fieldKey, type } = val;
  const target = data.columns?.find((x) => x.colKey === fieldKey);
  if (target) {
    const oldType = target.aggregationType;
    const oldValue = summaryOptions.data[fieldKey];
    const onError = () => {
      target.aggregationType = oldType;
      summaryOptions.data[fieldKey] = oldValue;
    };

    target.aggregationType = type;
    summaryOptions.data[fieldKey] = summaryStatus.loading;
    try {
      const res = await fieldAggregationService.updateAndGetListPageAggregation({
        entity: entity.value,
        id: data.viewId || props.viewId,
        ...highFilterParams.value,
        ...filterParams.value,
        aggregation: {
          fieldKey,
          type
        }
      });
      if (!res.error) {
        summaryOptions.data[fieldKey] = res.result[fieldKey] ?? summaryStatus.error;
      } else {
        Message.error(res.error?.msg || t('操作失败'));
        onError();
      }
    } catch (e) {
      console.error(e);
      onError();
    }
  }
};

// 新增
const addRow = () => {
  const params = { type: 30, viewId: props.viewId, entity: entity.value };
  emits('cbAdd', params);
};
const poolId = ref(); //线索池id
const activeRowKeys = ref([]);
/******************** 嵌套表格 start ***********************/
const expandedRowKeys = ref([]);
const nestColumnsFields = ref({});

const mouseDownStatus = ref(''); // 鼠标状态
const mouseUpStatus = ref(''); // 鼠标状态

const isShowNestTable = ref(false); //是否显示嵌套表格
const { fieldIconMapping } = useFields(); // 获取字段图标
const getFieldIcn = (field) => {
  return fieldIconMapping.value[Number(field.fieldType)];
};
//点击展开图标(加载二级)
const rehandleExpandChange = async ({ expandRowKeys }) => {
  expandedRowKeys.value = [];
  if (expandRowKeys && expandRowKeys?.length) {
    // 更新展开状态
    expandedRowKeys.value.push(expandRowKeys[expandRowKeys.length - 1]);
  }
  if (Object.keys(nestColumnsFields.value).length == 0) {
    await getNestField({ entity: entity.value, viewId: props.viewId });
    nestColumnsFields.value = nestColumnField.value;
    isShowNestTable.value = true;
  }
};
// 打开列选择
const openColSelect = () => {
  fhTableRef.value?.openColSelect?.();
};
const mask = ref(false); //是否显示蒙层
// 查看详情
const toDetails = (record) => {
  //获取对象entity
  activeRowKeys.value = [record.id];
  console.log('主属性跳转', record, activeRowKeys.value);
  //特殊产品显示不能点击状态
  if (data.specialProduct.includes(Number(entity.value))) return false;
  data.id = record?.id;
  mask.value = record?.mask;
  detailRef.value.openDialog();
};

//多层级获取对象
const getTableLevelEntity = () => {
  return entity.value || '';
};
data.setEntity = getTableLevelEntity(1);

/******************** 嵌套表格 end ***********************/
// const findAssociation = { label: t('属于当前值'), value: 'equals_current_value' };
//兼容自定义
if (entity.value >= 200) {
  permissionsObjList[entity.value] = `${entity.value}:edit`;
}
const detailRef = ref(); //公共抽离组件
// 是否在飞书环境ss
// const isFeiShuApp = window.h5sdk;
const highFilterParams = ref({}); //高级筛选参数
const tableData = ref([]); //表格数据
const localPageSizeKey = CONFIG.prefix + 'fhTablePageSize';
const psLocal = tools.getCookie(localPageSizeKey);
const paginationObj = ref({
  page: 1,
  pageSize: psLocal ? Number(psLocal) : 20,
  total: 0
}); //表格的分页数据
const paginationParams = ref({ page: 1, pageSize: psLocal ? Number(psLocal) : 20 }); //分页参数
// 分页事件(表格回调)
const paginationEvent = async (page, pageSize) => {
  remainderTableData.value = [];
  selectTableIds.value = [];
  allIds.value = [];
  paginationParams.value.page = page;
  paginationParams.value.pageSize = pageSize;
  tools.setCookie(localPageSizeKey, pageSize <= 100 ? pageSize : 100, 365);
  paginationObj.value = {
    ...paginationObj.value,
    current: page,
    pageSize: pageSize
  };
  await getTableData({ imperception: true });
  tableScrollToTop({ distance: 0 }); //滚动到顶部
};

const indeterminate = computed(() => {
  const selectedLength = selectTableIds.value.length;
  const allLength = allIds.value.length;
  // 提前返回，避免不必要的计算
  if (selectedLength === 0 || selectedLength >= allLength) {
    return false;
  }
  return selectedLength > 0 && selectedLength < allLength;
});
const tableRow = ref({}); //当前行数据
const bingDataList = ref([]); //bing特殊逻辑
// 全选（渲染100条复选框的状态变更略慢，JS大概0.5ms）
const selectAll = () => {
  if (selectTableIds.value.length === allIds.value.length) {
    selectTableIds.value = [];
  } else {
    selectTableIds.value = [...allIds.value];
  }
  // 全选但只有一条正常数据可选时，走的是行内编辑，此时需要该行数据
  if (selectTableIds.value.length === 1) {
    tableRow.value = tableData.value?.find((item) => item.id === selectTableIds.value[0]);
  } else {
    tableRow.value = {};
  }
};
// 单选
const selectSingle = (e, id) => {
  const newSelectedIds = e ? [...selectTableIds.value, id] : selectTableIds.value.filter((v) => v !== id);
  selectTableIds.value = newSelectedIds; // 一次性赋值，减少响应式触发
  // 如果仅剩余一套数据时，需要根据剩余ID获取该行数据
  tableRow.value = newSelectedIds.length === 1 ? tableData.value.find((item) => item.id === newSelectedIds[0]) : {};
  // 目前查询到该数据只有Bing租户的Bing数据同步按钮需要该参数，其他按钮不会用到，考虑根据Bing租户的orgId判断
  if (userInfo.orgId == bingOrgId) {
    getBingDataList();
  }
};
// bing的特殊逻辑
const getBingDataList = () => {
  // 提前获取必要的值，避免重复访问响应式对象
  const { value: tableDataVal } = tableData;
  const { value: selectTableIdsVal } = selectTableIds;
  const { value: entityVal } = entity;
  // 快速过滤出选中的数据
  const filterList = tableDataVal?.filter((v) => selectTableIdsVal?.includes(v.id)) || [];
  // 使用映射表替代多个 if-else 判断
  const fieldMap = {
    2: 'input_rbKcJb',
    3: 'account_id',
    10: 'id'
  };
  // 检查是否有直接映射的字段
  if (fieldMap[entityVal]) {
    bingDataList.value = filterList.map((v) => v[fieldMap[entityVal]]);
    return;
  }
  // 处理特殊情况
  if (entityVal >= 200 && userInfo?.roles?.includes(`${entityVal}:bingUserInviteSync`)) {
    bingDataList.value = filterList.map((v) => v?.id);
    return;
  }
  // 默认情况
  bingDataList.value = [];
};

// ---------这里是排查bug，增加的额外日志后期可以删除----------------------------------------------
// const sendLog = (params) => {
//   // 这里是排查bug，增加的额外日志后期可以删除
//   // 日志
//   const track = useVolLog();
//   const modeLists = ['production', 'pc2', 'matrixProd', 'kaixian'];
//   const mode = import.meta.env.MODE;
//   const userStore = useUserStore();
//   if (modeLists.includes(mode)) {
//     track.send({
//       type: 'newListPage',
//       page: window.location.href,
//       orgName: userStore.userInfo?.orgName || '-',
//       userName: userStore.userInfo?.userName || '-',
//       orgId: userStore.userInfo?.orgId || '-',
//       userId: userStore.userInfo?.id || '-',
//       feishu: !!window.h5sdk,
//       params: params
//     });
//   }
// };
// --------------这里是排查bug，增加的额外日志后期可以删除-----------------------------------------

/**************************列表初始化获取数据逻辑 S****************************** */
const remainderTableData = ref([]); // 剩余未加载完成的数据集合
const initLoadDataCount = 100; //列表分片的数量控制
const start = performance.now();
// 获取表格数据
const getTableData = async (loadParams) => {
  const page = loadParams?.page; //第几页
  const imperception = loadParams?.imperception; //如果传递该参数，则表示需要无感刷新
  try {
    if (page) {
      paginationParams.value.page = page;
    }
    const params = {
      entity: entity.value,
      id: data.viewId || props.viewId,
      ...paginationParams.value,
      ...highFilterParams.value,
      ...filterParams.value
    };
    const json = await tableService.getTableDataListPage(params);
    // console.log(123456789, '渲染开始', start + 'ms');
    if (!json.error) {
      // 处理返回数据
      const { records: _resultRecords, total } = json.result;
      remainderTableData.value = []; // 先清空剩余数据
      // 更新分页信息
      paginationObj.value = {
        ...paginationObj.value,
        total,
        current: paginationParams.value.page
      };
      emits('cbTotalCount', total);
      // tableData.value = [];
      // remainderTableData.value = [];
      // 设置表格数据
      tableData.value = imperception ? _resultRecords : _resultRecords.slice(0, initLoadDataCount);
      // 如果有剩余数据且不是无感刷新，设置剩余数据
      if (!imperception && _resultRecords.length > initLoadDataCount) {
        remainderTableData.value = _resultRecords.slice(initLoadDataCount);
      }
      // tableData.value = _resultRecords;
    }

    data.loading = false;
    // await nextTick(); // 👈 立刻刷新组件

    selectTableIds.value = []; // 清空选中数据
    emits('update:loading', data.loading);
    tools.requestIdleTask(() => {
      loadTableData();
      // 这里是排查bug，增加的额外日志后期可以删除
      // sendLog(params);
      // 这里是排查bug，增加的额外日志后期可以删除
    });
  } catch (error) {
    console.log(error);
    data.loading = false;
    emits('update:loading', data.loading);
  }
};
const { startPolling, refreshComputedStatus, clearTimer, allIds, errorRowList } = useComputedStatusPolling({
  tableData,
  entity,
  viewId: computed(() => data.viewId || props.viewId),
  delayGetSummary
});

// 加载剩余数据
const loadTableData = async () => {
  // 清除已有定时器
  clearTimer();
  await nextTick();
  // 一次性加载剩余所有数据
  if (remainderTableData.value?.length) {
    tableData.value.push(...remainderTableData.value);
    // 清空剩余数据
    remainderTableData.value = [];
  }
  // 统一处理状态计算
  if (tableData.value?.length) {
    await startPolling();
  } else {
    allIds.value = [];
  }
  console.log(123456789, '渲染结束', performance.now() + 'ms');
  console.log(123456789, '渲染总耗时', performance.now() - start + 'ms');
  await nextTick();
  // handleSearch('数字');
};
/**************************列表初始化获取数据逻辑 E****************************** */
// 点击表头上更多图标
const headerColInfo = ref({});
const isIconSubForm = ref(false);
const headerColumn = ref({});
const qfTableHeaderMoreRef = ref(null);
const headerIconMore = async (params) => {
  const { e, col, isSubForm = false, position } = params;
  console.log('headerIconMore', position, params);
  e.stopPropagation();
  const rect = e.currentTarget.getBoundingClientRect();
  isIconSubForm.value = isSubForm;
  headerColumn.value = col;
  headerColInfo.value = {
    ...col,
    top: rect.top + window.scrollY + 25 + 'px',
    left: rect.left + window.scrollX - 263 + 'px'
  };
  data.showColOverlay = true;
  // 置空鼠标状态
  mouseDownStatus.value = false;
  mouseUpStatus.value = false;
  await nextTick(() => {
    qfTableHeaderMoreRef.value?.clickMoreIcon();
  });
};
const filterParams = ref({});
const filterFieldArray = ref([]);
//表格
const fieldSearchParams = ref(null);
// const spacileTypeField = ref([]);
// 高级筛选组件的回调事件
const getSearchData = async (v, searchType) => {
  // 线索池特殊处理--存储线索池id
  if (searchType == 'fieldSearch') {
    // 关键字搜索特殊逻辑
    tableData.value = [];
    data.loading = true;
    fieldSearchParams.value = v?.searchFields;
  }
  // 重置listPage接口参数
  if (entity.value == 101 && v?.sceneId) {
    poolId.value = v?.sceneId;
  }
  if (!useFilterList?.isFirst) {
    data.ruleForm.conditions = v?.conditions || [];
  } else {
    data.ruleForm.conditions = useFilterList?.conditionsList;
  }
  if (v.type && !useFilterList?.isFirst) {
    // 保存筛选数据
    await useFilterList.setConditionsList({ entity: entity.value, conditions: v?.conditions });
  }
  delete v.type;
  // 更新筛选条件的值，导出组件使用
  const params = {
    viewId: data.viewId,
    filterParams: {
      conditions: useFilterList?.isFirst ? data.ruleForm.conditions : v?.conditions,
      sceneType: v.sceneType,
      sceneId: v.sceneId,
      searchFields: fieldSearchParams.value
    },
    pagination: paginationObj.value
  };

  keywords.value = fieldSearchParams.value?.value; // 关键字赋值
  searchFieldsList.value = fieldSearchParams.value?.field.map((vItem) => {
    if (vItem.subField) {
      return vItem.subField;
    }
    return vItem.field;
  });

  // 处理排序设置
  if (useFilterList?.fieldsSort?.length) {
    params.filterParams.sortSettings = useFilterList.fieldsSort.reduce((acc, item) => {
      if (item.fieldStatus == 1) {
        acc.push({
          ...item,
          sort: item.fieldSort
        });
      }
      return acc;
    }, []);
  }
  highFilterParams.value = params.filterParams;
  filterFieldArray.value = extractFields(params.filterParams.conditions); //处理筛选字段
  emits('cb', params);
  selectTableIds.value = [];
  // 如果初始化有排序字段，则需要手动添加到字段列表中
  if (useFilterList?.fieldsSort?.length) {
    addFieldsSort(); //更新表头筛选图标状态
  }
  // 此处要获取排序和筛选字段的fieldKey集合,filterFieldArray.value是筛选字段key集合未去重
  // const sortFieldKeys = params.filterParams?.sortSettings?.map((item) => item.fieldKey);
  // console.log('筛选字段', filterFieldArray.value, sortFieldKeys);
  // const filterFieldKeys = [...filterFieldArray.value, ...sortFieldKeys];
  // if (filterFieldKeys?.length) {
  //   spacileTypeField.value = Array.from(new Set(filterFieldKeys));
  // }
  // console.log('筛选字段', spacileTypeField.value);
  if (!useFilterList?.isFirst) {
    getSummaryData();
    await getTableData({ page: 1 });
    /* 首次加载在高级筛选已获取过，不用初次调取，后续每次条件更新都需要同步获取最新条件 */
    await useFilterList.getConditionsList({ entity: entity.value }); // 存储筛选条件
    data.ruleForm.conditions = useFilterList?.conditionsList;
  }
  useFilterList.setIsFirst(false);
};
// 表头单字段筛选参数
const getConditionParams = (params) => {
  console.log('conditionsList-8', params);
  if (params.type) {
    getSearchData({ ...params, type: true });
  }
};
// 如果需要列选择，就需要在自己需要的地方自定义一个按钮，实现table的这个事件 开始 S
const fhTableRef = ref(null); // 表格ref

const ids = ref([]);
const selectTableIds = ref([]); //选择的数据ID
// 快捷组件中按钮的回调
const shortcutBtnCb = (params) => {
  console.log(773, '快捷组件中按钮的回调', params, paginationObj.value.current);
  if (params?.type === 'refreshRow') {
    selectTableIds.value = selectTableIds.value.filter((v) => v !== params.id);
  }
  // 判断当前页是否删除完
  if (params?.setPage && paginationParams.value.page > 1) {
    paginationParams.value.page = paginationParams.value.page - 1;
  }
  refreshList(params);
};
// 追加排序字段
const addFieldsSort = () => {
  if (data.columns?.length) {
    data.columns?.forEach((item) => {
      const obj = fieldsSort.value?.find((e) => {
        return e.fieldKey == item.colKey;
      });
      if (obj) {
        if (obj.fieldSort === true || obj.fieldSort === false) {
          item.fieldSort = obj.fieldSort;
        } else {
          item.fieldSort = '';
        }
      } else {
        item.fieldSort = '';
      }
    });
  }
};
const resetSummaryData = () => {
  summaryOptions.data = data.columns.reduce((pre, item) => {
    if (isAggregationField(item.fieldType, item.fieldExt)) {
      pre[item.colKey] = summaryStatus.loading;
    }
    return pre;
  }, {});
};

// 获取表格表头字段
const getField = async (viewId) => {
  data.viewId = viewId?.viewId || props.viewId;
  // 缓存字段数据 (避免多次访问响应式对象)
  data.fieldList = useTableInfo.columnFieldList; // 列表字段
  data.multiTable = useTableInfo?.multiTable;

  // 如果初始化有高级筛选，则需要手动添加到字段列表中
  if (useFilterList?.conditionsList?.length) {
    data.ruleForm.conditions = useFilterList?.conditionsList; // 筛选条件
    filterFieldArray.value = extractFields(data.ruleForm.conditions); //处理筛选字段
  }
  // 列配置计算
  data.columns = getColumns();

  resetSummaryData();
  // 如果初始化有排序字段，则需要手动添加到字段列表中
  if (useFilterList?.fieldsSort?.length) {
    // console.log(123456789, 11111, useFilterList?.fieldsSort);
    addFieldsSort();
  }
};

// 排序  sort.isDefault == true  恢复默认  sort.isNull == true  清空所有
const sortChange = async (sort = null) => {
  // 默认排序
  if (typeof sort === 'object' && sort !== null) {
    if (sort.isDefault == true) {
      filterParams.value.sortSettings = useFilterList?.fieldsSortDefault?.length ? useFilterList?.fieldsSortDefault : [];
    }
    if (sort.isNull == true) {
      filterParams.value.sortSettings = [];
    }
  } else {
    // 自定义排序
    filterParams.value.sortSettings = useFilterList?.fieldsSort?.length ? useFilterList?.fieldsSort : [];
  }
  // 过滤掉 停用字段
  if (filterParams.value.sortSettings && filterParams.value.sortSettings?.length) {
    filterParams.value.sortSettings = filterParams.value.sortSettings?.filter((item) => item.fieldStatus != 2);
    // 添加 sort 与 fieldSort
    filterParams.value.sortSettings = filterParams.value?.sortSettings.map((item) => {
      item.sort = item.fieldSort;
      // delete item.fieldSort;
      return item;
    });
  }
  selectTableIds.value = [];
  showLay(false);
  addFieldsSort();
  await getTableData({ page: 1 });
};
// 标题冻结列
const colTitleFrozen = (key, value, newColumns) => {
  // 创建一个新的数组，避免直接修改原始数据
  const updatedColumns = newColumns?.map((item) => ({ ...item }));
  console.log(834, key, value, newColumns, updatedColumns, 'updatedColumns');
  // 分别筛选出左固定、右固定和非固定的列
  const fixedLeft = updatedColumns?.filter((item) => item.fixed === 'left' && item.colKey !== key);
  const fixedRight = updatedColumns?.filter((item) => item.fixed === 'right' && item.colKey !== key);
  const noFixed = updatedColumns?.filter((item) => !item.fixed && item.colKey !== key);
  // 找到当前列
  const current = updatedColumns?.find((item) => item.colKey === key);
  console.log(882, current);
  // 根据 value 来设置当前列的 fixed 属性
  if (value) {
    current.fixed = 'left';
    fixedLeft.push(current); // 将当前列放入左固定数组
  } else {
    current.fixed = undefined;
    noFixed.unshift(current); // 将当前列放入非固定数组的开头
  }
  // 组合新的列数组，确保顺序为左固定 -> 非固定 -> 右固定
  const newList = [...fixedLeft, ...noFixed, ...fixedRight];
  // data.columns = newList;
  // 假设 fhTableRef.value.getCols(newList) 可以正确处理顺序问题
  console.log('colTitleFrozen-newList', fhTableRef);
  fhTableRef.value.getCols(newList);
  console.log(847, newList);
  showLay(false);
};
// 定义回调函数，用于接收hooks中的事件并刷新表格数据
// const handleCallbackList = async (callback) => {
//   console.log(855, 'handleCallbackList', callback, spacileTypeField.value);
//   // 只有在callback.fieldKey包含筛选和排序中的字段时，需要刷新列表，否则都不刷新
//   if (spacileTypeField.value?.includes(callback?.fieldKey)) {
//     setTimeout(() => {
//       refreshList(); // 调用表格数据接口
//     }, 2000);
//   }
// };
// 从所有字段中获取表格头部标题
const getColumns = () => {
  const list = [];
  data.fieldList?.forEach((item) => {
    const colConfig = createColumnConfig(item, {
      tableData: tableData,
      entity: entity.value,
      tableLevel: 1,
      virtual: grayVirtualEnabled, // 虚拟列表
      // AI点数“重试”按钮成功后，直接复用主表现有刷新逻辑，避免单独维护局部更新状态。
      onAiPointsRetrySuccess: () => refreshList()
      // callbackList: handleCallbackList // 回调函数
    });
    if (item?.fieldType == 27) {
      colConfig.children = createChildColumns(item, {
        tableData: tableData,
        entity: entity.value,
        tableLevel: 1
        // callbackList: handleCallbackList // 回调函数
      });
    }
    list.push(colConfig);
  });

  return list;
};

// 是否显示按钮组件
const shouldShowButtonGroup = computed(() => {
  const hasSelection = selectTableIds.value?.length;
  const hasShortcut = props.shortcutBtnPermission?.length;
  const hasBatch = props.batchBtnPermission?.length;
  // 没有任何按钮配置时，永远不显示
  if (!hasSelection || (!hasShortcut && !hasBatch)) return false;
  // 有选择时才进一步判断
  if (hasSelection === 1 && !hasShortcut) return false;
  if (hasSelection > 1 && !hasBatch) return false;
  return true;
});

const shouldShowShortcutBtn = computed(() => {
  const isSingleSelect = selectTableIds.value?.length === 1;
  const hasShortcut = props.shortcutBtnPermission?.length > 0;
  // 仅当单选且配置了快捷按钮时显示
  return isSingleSelect && hasShortcut;
});

const shouldShowBatchBtn = computed(() => {
  const isMultiSelect = selectTableIds.value?.length > 1;
  const hasBatch = props.batchBtnPermission?.length > 0;
  // 仅当多选且配置了批量按钮时显示
  return isMultiSelect && hasBatch;
});

const handleMouseDown = () => {
  mouseDownStatus.value = true;
  console.log('mousedown-mousedown 事件触发');
};
const handleMouseUp = () => {
  mouseUpStatus.value = true;
  if (mouseDownStatus.value && mouseUpStatus.value) {
    showLay(false);
  }
};

// 遮罩层
const showLay = async (val) => {
  if (!val && qfTableHeaderMoreRef.value) {
    qfTableHeaderMoreRef.value.closedOverLay();
  }
  await nextTick();
  data.showColOverlay = val;
};
// 清除选中
const clearSelected = () => {
  ids.value = [];
  selectTableIds.value = [];
};
//重置刷新列表
const batchBtnCb = async (v = null) => {
  console.log(948, v);
  clearSelected();
  // 判断当前页是否删除完
  if (v?.setPage && paginationParams.value.page > 1) {
    paginationParams.value.page = paginationParams.value.page - 1;
  }
  await getTableData({ imperception: true });
  delayGetSummary();
};

watch(
  () => useFilterList?.fieldsSort,
  (v) => {
    fieldsSort.value = v;
  },
  {
    deep: true,
    immediate: true
  }
);

const currentNewColumns = ref([]); //实时更新列宽显示
// 列宽拖拽实时获取列宽
const columnResize = (record, showCol) => {
  currentNewColumns.value = showCol; //实时更新列宽显示
  console.log(1085, record, showCol);
};
// 表格行滚动事件-->参数：params：{ direction: 'left' | 'right' | 'top' | 'bottom'， distance: number, distance: number }，direction：滚动方向，distance：滚动距离
const tableScrollEvent = async (params) => {
  //例如： params = { x: 0, y: 0,  };
  console.log('tableScrollEvent', params);
  if (fhTableRef.value) {
    fhTableRef.value?.tableScrollEvent(params);
  }
};
const tableScrollToTop = (params) => {
  fhTableRef.value?.scrollToTop(params);
};
// 获取左侧固定列最后一列到视口左侧的距离
const getFixedLeftLastCellRect = (level = 1) => {
  return fhTableRef.value?.getFixedLeftLastCellRect(level);
};

// 获取Qf-table的表体实例方法
const getTableBodyRef = (level = 1) => {
  return document.querySelectorAll('.qf-table-body')?.[level - 1];
  //return fhTableRef.value?.getTableBodyRef(level);
};
// 获取表格滚动容器的实例方法
const getScrollContainerRef = (level = 1) => {
  return fhTableRef.value?.getScrollContainerRef(level);
};
// 获取Qf-table的表头实例方法
const getTableHeaderRef = (level = 1) => {
  return fhTableRef.value?.getTableHeaderRef(level);
};
// 提供修改行数据的z-index方法
const updateZIndex = ({ rowKey, zIndex }) => {
  if (!fhTableRef.value) return;
  fhTableRef.value?.updateZIndex({ rowKey, zIndex });
};
provide('defaultParams', {
  id: computed(() => data.id),
  entity: computed(() => entity.value),
  viewId: computed(() => data.viewId), //兼容多层级表格
  poolId: computed(() => poolId.value),
  columns: computed(() => (currentNewColumns.value?.length ? currentNewColumns.value : data.columns)),
  keywords: computed(() => keywords.value), // 搜索值
  searchFieldsList: computed(() => searchFieldsList.value) // 搜索字段
});

// provide('globalParams', {
//   id: computed(() => data.id),
//   entity: computed(() => data.entity),
//   viewId: -1
// });
provide('tableMethods', {
  tableScrollEvent: tableScrollEvent,
  getFixedLeftLastCellRect: getFixedLeftLastCellRect,
  updateZIndex: updateZIndex
});
provide('mainTableMethods', {
  getTableBodyRef: getTableBodyRef,
  getTableHeaderRef: getTableHeaderRef,
  tableScrollToTop: tableScrollToTop,
  toDetails: toDetails,
  getScrollContainerRef: getScrollContainerRef
});
// const scrollTop = ref(0);
// 刷新列表
const refreshList = async (tp) => {
  if (tp === 'cancel') return;
  // 重新请求数据（触发表格重新渲染）
  if (tp !== 'detail') {
    console.log('刷新列表', 2);
    selectTableIds.value = [];
  }
  await getTableData({ imperception: true });
  if (tp === 'refresh') {
    getSummaryData();
  } else {
    delayGetSummary();
  }
};
// 公共按钮组件事件回调
const universalRefreshList = async () => {
  data.loading = true;
  emits('update:loading', data.loading);
  selectTableIds.value = [];
  await getTableData();
  delayGetSummary();
};
const getLoadTableList = async function () {
  if (useLayout?.changeViewId?.[entity.value]) {
    data.viewId = useLayout?.changeViewId?.[entity.value];
    selectTableIds.value = [];
    getField(data.viewId);
  }
  getTableData();
};
// 行拖拽排序
const rowDragParams = computed(() => ({
  enabled: userInfo?.roles?.includes(props.entityId >= 200 ? 'object:custom' : 'object:system'),
  disabled: !!useFilterList.fieldsSort.length,
  disabledTip: '已设置排序规则，无法手动拖拽'
}));
/**
 * @description 拖动行事件结束
 * @param {object} e
 * @param {MouseEvent} e.e 事件对象
 * @param {object} e.sourceRow 拖动的行数据
 * @param {number} e.sourceIndex 拖动的行索引
 * @param {number} e.targetIndex 目标行索引
 * @returns {void}
 */
const onRowDragEnd = async (e) => {
  const { sourceRow, targetIndex } = e;
  /**
   * @type {Parameters<typeof tableService.setDataSort>[0]}
   */
  const params = {
    ids: null,
    nextId: null,
    preId: null,
    viewId: props.viewId,
    entity: props.entityId
  };
  // 当拖拽的元素被选中时 连同其他元素一起拖拽 并保证顺序
  const sourceRows = selectTableIds.value.includes(sourceRow.id) ? tableData.value.filter((x) => selectTableIds.value.includes(x.id)) : [sourceRow];
  params.ids = sourceRows.map((x) => x.id);

  const oldList = [...tableData.value];

  let newList = [...tableData.value];
  // 将拖动的数据数组不展开前先插入到新数组中 再过滤掉新数组中被拖动的数据
  // 找到拖动的数据数组在新数组中的索引 此索引减一就是preId  此索引加一就是nextId
  // 这里可以避免用户鼠标放下的目标数据在被拖动的数据中时preId或nextId会在params.ids中 导致后端报错
  newList.splice(targetIndex, 0, sourceRows);
  const sourceIds = new Set(params.ids);
  newList = newList.filter((x) => !sourceIds.has(x.id));
  const sourceRowsIndex = newList.indexOf(sourceRows);
  if (sourceRowsIndex > 0) {
    params.preId = newList[sourceRowsIndex - 1].id;
  } else {
    const nextIdIndex = sourceRowsIndex + 1;
    params.nextId = newList[nextIdIndex]?.id;
  }

  console.log('拖拽结束', params);

  if (params.preId == null && params.nextId == null) {
    // 这里是用户全选后做了拖拽,preId 和 nextId 都为空 则不做排序
    return;
  }

  let apiError = false;
  // 大数据量时同步更新会导致UI卡顿一下
  tools.requestIdleTask(() => {
    // 如果是网络离线 这里会在接口catch触发后执行
    if (apiError) return;
    tableData.value = newList.flat();
  });
  // 调用接口设置排序
  try {
    const { error } = await tableService.setDataSort(params);
    if (error) {
      throw Error(error.msg);
    }
  } catch (e) {
    apiError = true;
    tableData.value = oldList;
    Message.error('操作失败，请重试！');
    throw e;
  }
};
// 完整 onMounted 逻辑
onMounted(async () => {
  // 将getFieldAndNest和getTableData的调用放在Promise.all中，以并行方式执行
  // getFieldAndNest存储在store中，以便父级使用（排序组件中需要使用）
  console.log(1087, '进入列表页');
  const fieldInfoPromise = useTableInfo.getFieldAndNestInfo({ entity: entity.value, viewId: props.viewId || null });
  // 当 getFieldAndNestInfo 完成时立即触发 getField,提前渲染表头信息
  fieldInfoPromise.then(() => {
    getField(props.viewsObj);
  });
  await Promise.all([fieldInfoPromise, getTableData()]);
  emits('loadAdvancedComp', true);
});
onBeforeUnmount(() => {
  console.log(1589, 'fh-layout-unmount', '表格组件卸载了');
  clearTimer();
  if (getSummaryTimer) {
    clearTimeout(getSummaryTimer);
    getSummaryTimer = null;
  }
  data.columns = [];
  tableData.value = [];
  selectTableIds.value = [];
  allIds.value = [];
  data.fieldList = [];
  data.ruleForm.conditions = [];
  // 清理 DOM 引用
  fhTableRef.value = null;
  detailRef.value = null;
  qfTableHeaderMoreRef.value = null;
  // 清理缓存
  provide('mainTableMethods', null);
  provide('tableMethods', null);
  provide('defaultParams', null);
});
// 确保所有定时器都被清理
onUnmounted(() => {
  clearTimer();
  clearTimeout(getSummaryTimer);
});
defineExpose({ getField, toDetails, universalRefreshList, getLoadTableList, openColSelect, refreshList, sortChange, getSearchData, getSummaryData });
</script>
<style scoped lang="less">
@import './fh-main-table.less';
</style>
